import React, { Fragment, useState } from "react";
import MaterialTable from "../../../../components/materialTable";
import DialogAdd from "./dialogAdd";
import DialogUpdate from "./dialogUpdate";
import DialogDelete from "./dialogDelete";

export default function Page(props) {
	let {
		instituciones,
		is_loading,
		mutate_instituciones,
	} = props;

	const [IsOpen, SetIsOpen] = useState({});

	let columns = [
		{
			title: "Nombre",
			field: "valor"
		},
	];

	let actions = [
		{
			icon: "edit",
			tooltip: "Actualizar",
			onClick: (event, row) => SetIsOpen({ tipo: "update", data: row }),
		}, {
			icon: "delete",
			tooltip: "Eliminar (Requiere confirmación)",
			onClick: (event, row) => SetIsOpen({ tipo: "delete", data: row }),
		}, {
			icon: "add",
			tooltip: "Agregar",
			isFreeAction: true,
			onClick: (event, row) => SetIsOpen({ tipo: "add", data: row }),
		}
	];

	const handleCloseDialog = () => {
		SetIsOpen({});
	}

	return (
		<Fragment>
			{/* LISTADO DE INSTITUCIONES */}
			<MaterialTable
				title="Instituciones"
				is_loading={is_loading}
				data={instituciones ? instituciones.data : []}
				columns={columns}
				actions={actions}
				export_excel={true}
				export_spreadsheet={true}
			/>

			{/* DIALOG PARA AGREGAR */}
			{IsOpen.tipo === "add" && (
				<DialogAdd
					is_open={IsOpen.tipo === "add"}
					handle_close={handleCloseDialog}
					mutate_instituciones={mutate_instituciones}
				/>
			)}

			{/* DIALOG PARA ACTUALIZAR */}
			{IsOpen.tipo === "update" && (
				<DialogUpdate
					is_open={IsOpen.tipo === "update"}
					data={IsOpen.data}
					handle_close={handleCloseDialog}
					mutate_instituciones={mutate_instituciones}
				/>
			)}

			{/* DIALOG PARA ELIMINAR */}
			{IsOpen.tipo === "delete" && (
				<DialogDelete
					is_open={IsOpen.tipo === "delete"}
					data={IsOpen.data}
					handle_close={handleCloseDialog}
					mutate_instituciones={mutate_instituciones}
				/>
			)}
		</Fragment>
	);
}